import React from 'react';
import { TextVariant } from '@naf/text';
import { Tag } from '@naf-simba/elements-tag';
import { getLabelVariant } from '@lib/getLabelVariant';
import { ButtonGroup, MediaComponent, Step } from '../StyledFeaturedBenefitBlock';
import { Content, Description, Heading, HeadingBlock, Steps, TagWrapper, Wrapper } from '../Styles';
import { FeaturedBenefitBlockTypeProps } from '../FeaturedBenefitBlock/FeaturedBenefitBlock';
import BenefitsList from '../../../../benefits-list/BenefitsList';
import Timer from '../../CountdownBlock/Timer';
import * as S from './HorizontalWithMedia.styles';

export const HorizontalWithMedia: React.FC<FeaturedBenefitBlockTypeProps> = ({ block }) => {
  const {
    title,
    colorVariant,
    description,
    tag,
    primaryCta,
    secondaryCta,
    image,
    video,
    steps,
    membershipBenefits,
    countdownTo,
  } = block;
  const tagVariant = getLabelVariant(colorVariant);

  return (
    <>
      <Wrapper $variant={colorVariant} $breakEarly={!!countdownTo}>
        <Content>
          {tag && (
            <TagWrapper>
              <Tag text={tag} color={tagVariant.color} />
            </TagWrapper>
          )}
          <S.StyledTop>
            <Heading variant={TextVariant.Display}>
              <HeadingBlock value={title} />
            </Heading>
            {description && <Description>{description}</Description>}
          </S.StyledTop>
          {steps && (
            <Steps>
              {steps.map((step, i) => (
                <Step key={step._key ?? `step-${i}`} step={step} index={i + 1} variant={colorVariant} />
              ))}
            </Steps>
          )}
          <S.Bottom $breakEarly={!!countdownTo}>
            <S.ButtonGroupWrapper $breakEarly={!!countdownTo}>
              <ButtonGroup colorVariant={colorVariant} primaryCta={primaryCta} secondaryCta={secondaryCta}>
                {countdownTo && (
                  <S.TimerWrapper>
                    <Timer targetTime={countdownTo} />
                  </S.TimerWrapper>
                )}
              </ButtonGroup>
            </S.ButtonGroupWrapper>
            {membershipBenefits && membershipBenefits.length > 0 ? (
              <S.BenefitWrapper>
                <BenefitsList size="standard" benefitItems={membershipBenefits} />
              </S.BenefitWrapper>
            ) : (
              <S.MediaWrapper>
                <MediaComponent video={video} image={image} />
              </S.MediaWrapper>
            )}
          </S.Bottom>
        </Content>
      </Wrapper>
      <S.Spacer />
    </>
  );
};
